import React from 'react';

import { OverlayState } from './types';

export const OverlayContext = React.createContext<OverlayState>({} as OverlayState);
